import styled from 'styled-components';

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.img<{ $isHeader?: boolean }>`
  height: ${props => props.$isHeader ? '32px' : '38px'};
  width: auto;
  object-fit: contain;
`;

export const LogoText = styled.div<{ $isHeader?: boolean }>`
  font-size: ${props => props.$isHeader ? '28px' : '34px'};
  font-weight: bold;
  color: ${props => props.$isHeader ? '#fff' : '#1890ff'};
  white-space: nowrap;
  padding: 8px 0;
`;
